import * as R from 'ramda'
import moment from 'moment'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import { sort, currentSort, db } from './common'
import { commentsByObjectID } from './index'
import { filteredCollection } from './filters'
import { attachmentsByObjectID } from './attachments'
import { createSearchAction, getSearchSelectors } from 'redux-search'
import { transactions } from './entities'

const paymentMethods = {
	"QuickBooks": "Bank transaction"
  , "Card": "Credit/ATM card"
  , "Paper check": "Paper check"
  , "Paypal": "Paypal"
}

const categories = {
	"70000 Property Expenses:70010 Advertising": "Advertising",
	"70000 Property Expenses:70020 Appliances": "Appliances",
	"70000 Property Expenses:70030 Cleaning and maintenance": "Cleaning and maintenance",
	"70000 Property Expenses:70030 Cleaning and Maintenance": "Cleaning and maintenance",
	"70000 Property Expenses:70040 HOA fees": "HOA fees",
	"70000 Property Expenses:70050 Insurance": "Insurance",
	"70000 Property Expenses:70060 Legal and Other fees": "Legal and Other fees",
	"70000 Property Expenses:70070 Management fees": "Management fees",
	"70000 Property Expenses:70070 Management Fees": "Management fees",
	"70000 Property Expenses:70070 Miscellaneous": "Miscellaneous",
	"70000 Property Expenses:70090 Mortgage interest": "Mortgage interest",
	"70000 Property Expenses:70100 Mortgage principle": "Mortgage principle",
	"70000 Property Expenses:70110 Repair": "Repair",
	"70000 Property Expenses:70120 Taxes": "Taxes",
	"70000 Property Expenses:70130 Utilities": "Utilities",
	"Deposit": "Deposit",
	"Rent": "Rent",
	"Fee": "Fee"
}
let sortOptions = (currentSort) => ({
	secondary: currentSort.sortBy == 'dueDate' ? 'property' : 'dueDate'
  , secondaryDirection: currentSort.sortBy == 'dueDate' ? 'ASC' : 'DESC'
})

export let transactionsEx = createSelector(
	[filteredCollection('transaction'), db, commentsByObjectID, attachmentsByObjectID, sort('transaction', sortOptions)],
	(transactions, db, commentsByObjectID, attachmentsByObjectID, sort) => {
		let party = transaction => {
			let party = db[transaction.partyID || transaction.vendorID] || {}
			return party.tenant || (party.firstName || "") + " " + (party.lastName || "")
		}
		let description= transaction => {
			if (transaction.memo) return transaction.memo
			let lines = transaction.expenses || transaction.lines || []
			return lines.map(x => x.memo || x.categoryName || categories[x.category] || '').join(', ')
		}
		let extend = transaction => {

			let property = transaction.propertyID && db[transaction.propertyID]
			return {
				...transaction
			  , comments: commentsByObjectID[transaction._id] || []
			  , attachments: attachmentsByObjectID[transaction._id] || []
			  , property: (property && property.alias) || ""
			  , party: party(transaction)
			  , description: description(transaction)
			  , paymentMethod: !transaction.paymentMethod && transaction.qbid ? "Bank transaction" : paymentMethods[transaction.paymentMethod] || ""
			  , type: transaction.type=='transaction/bill'?"bill"+(transaction.isPaid !="true"):"invoice"+(transaction.balance<=0)
			  , id: transaction._id
			  , amountString: transaction.amount && transaction.amount.toString()
			  , amount: transaction.type.indexOf('invoice')==-1?+transaction.amount:-transaction.amount
			  , dueDateString: moment(transaction.dueDate).format('DD MMM YYYY')
			}
		}
		return R.map(extend)(transactions)
	}
  , 'transactionsEx2'
)

let {
	text
  , result //  ids
  , unfilteredResult
} = getSearchSelectors({
	resourceName: 'transaction'
  , resourceSelector: (resourceName, state) => transactionsEx(state)
})

export let transactionsTable = createSelector(
	[transactionsEx, text, result, unfilteredResult, sort('transaction', sortOptions)]
  ,	(transactionsEx, text, result, unfilteredResult, sort) => {
		if (text) {
			transactionsEx = R.filter(x=>x)(R.map(id => transactionsEx[id], unfilteredResult))
		}
		return sort.fn(transactionsEx)
 	}
  , 'transactionsTable'
)



// WEBPACK FOOTER //
// ./src/selectors/transactionsTable.js